'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const XLM = {
    name: 'XLM',
    decimals: 7,
    isCryptoCurrency: true
};

exports.default = XLM;
//# sourceMappingURL=xlm.js.map
